import { useState } from "react";
import { toast } from "react-toastify";
import { Button, FormControl, InputLabel, MenuItem, Select, Box, Typography, Input, Dialog } from "@mui/material";
import { url } from "../api/axios_client";
import axios from "../api/axios_client";

const ReportPreview = ({ source, data, onUpload }) => {
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [uploading, setUploading] = useState(false);
    const [reportName, setReportName] = useState("");

    const countries = [
        "Algeria",
        "Bahrain",
        "Comoros",
        "Djibouti",
        "Egypt",
        "Iraq",
        "Jordan",
        "Kuwait",
        "Lebanon",
        "Libya",
        "Mauritania",
        "Morocco",
        "Oman",
        "Palestine",
        "Qatar",
        "Saudi Arabia",
        "Somalia",
        "Sudan",
        "Syria",
        "Tunisia",
        "United Arab Emirates",
        "Yemen"
    ];

    const handleUpload = async () => {
        if (!selectedCountry || !reportName) {
            toast.error("Please fill in all required fields");
            return;
        }

        console.log("data", data);

        try {
            setUploading(true);
            const response = await axios.post(`${url}/reports`, {
                source: source === "reporting" ? "monitoring" : source,
                name: reportName,
                country: selectedCountry,
                container: data.container,
                blob: data.blob
            });

            if (response.status === 201) {
                toast.success("Report uploaded successfully");
                setOpenUploadDialog(false);
                onUpload?.();
            } else {
                toast.error("Failed to upload report");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setUploading(false);
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={3}
            p={4}
        >
            <Typography variant="h5" gutterBottom>
                Report Generated Successfully
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
                Please note: This report will be automatically deleted after one hour if it is not uploaded.
            </Typography>

            <Box display="flex" gap={2}>
                <Button
                    variant="contained"
                    color="primary"
                    href={data.url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Download Report
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setOpenUploadDialog(true)}
                >
                    Upload to Repository
                </Button>
            </Box>

            <Dialog
                open={openUploadDialog}
                onClose={() => setOpenUploadDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <Box p={3}>
                    <Typography variant="h6" gutterBottom>
                        Upload Report to Repository
                    </Typography>

                    <Box display="flex" flexDirection="column" gap={3} mt={2}>
                        <FormControl fullWidth>
                            <InputLabel>Report Name</InputLabel>
                            <Input
                                value={reportName}
                                onChange={(e) => setReportName(e.target.value)}
                            />
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel>Select Country</InputLabel>
                            <Select
                                value={selectedCountry}
                                onChange={(e) => setSelectedCountry(e.target.value)}
                                label="Select Country"
                            >
                                {countries.map((country) => (
                                    <MenuItem key={country} value={country}>
                                        {country}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Box display="flex" gap={2} justifyContent="flex-end">
                            <Button
                                onClick={() => setOpenUploadDialog(false)}
                                variant="outlined"
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleUpload}
                                disabled={uploading || !selectedCountry || !reportName}
                            >
                                {uploading ? "Uploading..." : "Upload"}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Dialog>
        </Box>
    );
};

export default ReportPreview;